module.exports = __webpack_public_path__ + "static/media/PC_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.3584f09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ethical hacking/PC_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png
// module id = 77
// module chunks = 0